import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { json, Link, useLocation, useNavigate } from "react-router-dom";
import { updateItemId } from "SearchResults/SearchSlice";
import DefaultImage from "../../assets/default/images/placeholder.jpg";
import { setSelectedCategoryTagId } from "../../redux/features/landingSlice";
import { isOutofStock } from "../../utils/isOutOfStockHelper";
import moment from "moment";
import ProgressiveImg from "../ProgressiveImage";
import useAdminHelperFunction from "../../CustomHooks/useAdminHelperFunction";

function Item({ itemData, setIsCollect, setCollectedItem }) {
  const {
    itemId = 0,
    itemNumber = 0,
    description = "",
    longDescription = "",
    unitPrice = 0,
    mediaList = [],
    nab,
    webOrderable,
    webVisible,
    attribute1 = [],
    createdOnDate,
    promotedOn,
    digitalItemFlag,
    itemAttributes,
    ddrFlag,
    expirationDate,
    isBackOrder,
    templateFlag,
    efulfillmentFlag
  } = itemData;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { nabCheck, new_item_display_days, expired_item_display_days } =
    useSelector((state) => state.landing);
  const { companyNumber } = useSelector((state) => state.login);
  const onItemDetail = (id, templateFlag, efulfillmentFlag) => {
    dispatch(setSelectedCategoryTagId(null));
    dispatch(updateItemId(id));
    localStorage.setItem("itemId", id);
    navigate(`/${templateFlag ? "templateDetail" : efulfillmentFlag ? "emailDetail" : "itemDetail"}/${id}`);
  };

  const onCollect = (obj) => {
    setIsCollect(true);
    dispatch(setSelectedCategoryTagId(null));
    setCollectedItem([{ ...obj, isActive: true }]);
  };

  const expiringSoonBadge = useAdminHelperFunction("expiringSoon");

  const currentDate = moment();
  const createdDateNew = moment.utc(promotedOn, "YYYY-MM-DD hh:mm A");
  const diff = currentDate.diff(createdDateNew, "days") + 1;
  const expiration = moment.utc(expirationDate, "YYYY-MM-DD hh:mm A");
  const expireDiff = expiration.diff(currentDate, "days");

  const handleBanners = useCallback(() => {
    if (
      expiration.isBefore(currentDate) &&
      diff <=
        (expired_item_display_days && expired_item_display_days?.length
          ? parseInt(expired_item_display_days[0] || 30)
          : 30)
    ) {
      return <div className="expired-item">EXPIRED</div>;
    }
    if (
      !webOrderable &&
      webVisible &&
      itemAttributes?.validForUse === "No - Discontinued"
    ) {
      return <div className="expired-item">Discontinued</div>;
    }
    if (!webOrderable && webVisible && itemAttributes?.validForUse === "Yes") {
      return <div className="out-of-stock">Temporarily Unavailable</div>;
    }
    if (
      !(ddrFlag || isBackOrder || (digitalItemFlag && nabCheck !== "true")) &&
      nab <= 0
    ) {
      return <div className="out-of-stock">Out of Stock</div>;
    }
    if (expireDiff <= 30) {
      return expiringSoonBadge?.showField ? (
        <div className="sale-item">EXPIRES SOON</div>
      ) : null;
    }
    if (
      (diff >= 0 &&
      diff <=
        (new_item_display_days && new_item_display_days?.length
          ? parseInt(new_item_display_days[0] || 30)
          : 30)) || (itemAttributes && itemAttributes.newItemFlag)
    ) {
      return <div className="new-item">NEW ITEM</div>;
    }
    return null;
  }, [new_item_display_days, expiringSoonBadge]);

  const CollectionItemLabel = useAdminHelperFunction("Collection_item_label");

  return (
    <>
      <div className="tile">
        {handleBanners()}
        <div
          onClick={() => onItemDetail(itemId, templateFlag, efulfillmentFlag)}
          className="tile-container"
        >
          <div className="tile-img">
            {mediaList &&
            mediaList[0]?.url &&
            mediaList[0]?.mediaType?.imageFlag ? (
              <ProgressiveImg src={mediaList[0].url} />
            ) : (
              <img src={DefaultImage} alt="" />
            )}
          </div>
          <div
            className="item-code margin-top2"
            dangerouslySetInnerHTML={{
              __html: itemNumber,
            }}
          >
            {/* {itemNumber} */}
          </div>
          {description ? (
            <div
              className="title"
              title={description}
              dangerouslySetInnerHTML={{
                __html: description,
              }}
            ></div>
          ) : null}
          {longDescription ? (
            <div
              className="description"
              title={longDescription}
              dangerouslySetInnerHTML={{
                __html: longDescription,
              }}
            ></div>
          ) : null}
          <div className="item-code margin-top3">
            <a href="">{attribute1.join(",")}</a>
          </div>
        </div>
        <div
          className="tile-bottom"
          style={
            templateFlag
              ? {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }
              : {}
          }
        >
          {" "}
          <div
            className="view-item"
            onClick={() => onItemDetail(itemId, templateFlag, efulfillmentFlag)}
            style={templateFlag ? { marginLeft: "-1rem" } : {}}
          >
            <span href="">
              <i className="fa fa-tag"></i>
            </span>
            VIEW ITEM
          </div>
          {CollectionItemLabel?.showField && !templateFlag ? (
            <button
              className="collected"
              disabled={isOutofStock(webOrderable, webVisible, nab, ddrFlag)}
              onClick={() =>
                onCollect({
                  itemId,
                  itemNumber,
                  description,
                  longDescription,
                  unitPrice,
                  mediaList,
                  nab,
                  webOrderable,
                  webVisible,
                })
              }
            >
              <i className="fa fa-bookmark"></i>
              {CollectionItemLabel?.clientSpecificLabel ||
                CollectionItemLabel?.defaultLabel}
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
}

export default Item;
